<template>
  <div>
    <div class="mt-2">
      <p>Visualiza cómo lucirá tu Checkout con los elementos personalizados aplicados en la simulación. Si necesitas realizar ajustes, puedes volver a los pasos anteriores antes de guardar y activar. Esta es una representación ilustrativa. Los métodos de pago reales disponibles se visualizarán directamente desde tu tienda Shopify.</p>
    </div>

    <div>
      <div class="actions-btn">
        <b-button @click="prev" size="sm" variant="warning" class="mr-3 arrow-buttons">
          <feather-icon
            icon="ArrowLeftCircleIcon"
            size="20"
          />
        </b-button>

        <div class="text-center card">
          <div class="mb-2 mt-2">
            <div class="text-center container-preview--logo">
              <img :src="IconLogoDefault" alt="Logo por defecto"/>
            </div>
          </div>

          <div>
            <b-tabs v-model="activeTab" fill>
              <b-tab>
                <template #title>
                  <b-avatar size="sm" :variant="activeTab === 0 ? 'primary' : 'secondary'" class="mr-1">1</b-avatar>
                  {{ $t('Identificación') }}
                </template>
                <PreviewTabIdentification :buttons-color="buttonsColor" />
              </b-tab>
              <b-tab>
                <template #title>
                  <b-avatar size="sm" :variant="activeTab === 1 ? 'primary' : 'secondary'" class="mr-1">2</b-avatar>
                  {{ $t('Entrega') }}
                </template>
                <PreviewTabDelivery
                  :selected-home="selectedHome"
                  :selected-pudo="selectedPudo"
                  :selected-delivery="selectedDelivery"
                  :free-shipping-home="freeShippingHome"
                  :free-shipping-pudo="freeShippingPudo"
                  :free-shipping-domicilio="freeShippingDomicilio"
                  :badges-color="badgesColor"
                />
              </b-tab>
              <b-tab>
                <template #title>
                  <b-avatar size="sm" :variant="activeTab === 2 ? 'primary' : 'secondary'" class="mr-1">3</b-avatar>
                  {{ $t('Pago') }}
                </template>
                <PreviewTabPayment :buttons-color="buttonsColor"  />
              </b-tab>
            </b-tabs>
          </div>

          <div class="slider-indicators">
            <feather-icon
              v-for="i in 3"
              :key="i"
              icon="CircleIcon"
              size="16"
              stroke="#F18805"
              :fill="activeTab === i - 1 ? '#F18805' : 'none'"
            />
          </div>
        </div>

        <b-button @click="next" size="sm" variant="warning" class="ml-3 arrow-buttons">
          <feather-icon
            icon="ArrowRightCircleIcon"
            size="20"
          />
        </b-button>
      </div>
    </div>

    <div class="w-full d-flex justify-content-end mt-2 mb-4">
      <b-button @click="saveAndContinue" class="push-right custom-btn-create" variant="warning">
        <b-spinner small v-if="loading.create"/>
        <span v-else>Guardar y Activar</span>
      </b-button>
    </div>
  </div>
</template>
<script>
import PreviewTabDelivery from '../components/PreviewTabDelivery.vue'
import PreviewTabIdentification from '../components/PreviewTabIdentification.vue'
import PreviewTabPayment from '../components/PreviewTabPayment.vue'
import defaultLogo from '@/assets/images/icons/company_default_grey.png'
export default {
  components: {
    PreviewTabIdentification,
    PreviewTabDelivery,
    PreviewTabPayment
  },
  props: {
    selectedHome: Boolean,
    selectedPudo: Boolean,
    selectedDelivery: Boolean,
    freeShippingHome: Boolean,
    freeShippingPudo: Boolean,
    freeShippingDomicilio: Boolean,
    minAmountDomicilio: Number,
    badgesColor: String,
    buttonsColor: String
  },
  data () {
    return {
      activeTab: 0,
      IconLogoDefault: defaultLogo,
      loadingSpinner: true,
      loading: {
        create: false
      }
    }
  },
  methods: {
    saveAndContinue() {
      this.loading.create = true
      this.$emit('guardar-y-activar')
      this.loading.create = false
      this.loadingSpinner = false

    },
    next() {
      this.activeTab += 1
      if (this.activeTab >= 3) {
        this.activeTab = 0 // Reset to first tab if needed
      }
    },
    prev() {
      this.activeTab -= 1
      if (this.activeTab < 0) {
        this.activeTab = 2 // Reset to last tab if needed
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.actions-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.arrow-buttons {
  border-radius: 100%;
  padding: 10px;
}
.slider-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px
}
.container-preview--logo img{
  height: 70px;
  max-height: 70px;
}
</style>